export const isStringArray = (value: unknown): value is string[] =>
    Array.isArray(value) && value.every((v) => typeof v === "string");

export const isNumberArray = (value: unknown): value is number[] =>
    Array.isArray(value) && value.every((v) => typeof v === "number");

export const isBooleanArray = (value: unknown): value is boolean[] =>
    Array.isArray(value) && value.every((v) => typeof v === "boolean");

export const isNullableNumberArray = (value: unknown): value is (number | null)[] =>
    Array.isArray(value) && value.every((v) => typeof v === "number" || v === null);

export const isComplexityArray = (value: unknown): value is (number | "auto")[] =>
    Array.isArray(value) && value.every((v) => typeof v === "number" || v === "auto");

export const isNullableBooleanArray = (value: unknown): value is (boolean | null)[] =>
    Array.isArray(value) && value.every((v) => typeof v === "boolean" || v === null);

export const isObject = <T extends object = Record<string, unknown>>(value: unknown): value is T =>
    value !== null && typeof value === "object" && !Array.isArray(value);

export const isStringRecord = (value: unknown): value is Record<string, string> =>
    isObject(value) && Object.values(value).every((v) => typeof v === "string");
